const sanitizeName = (value, { trimEnd = false } = {}) => {
    let out = (value || '').replace(/\s/g, '-'); // each whitespace -> a dash

    // Keep trailing '-' while typing; trim only for submit/save if requested
    if (trimEnd) {
        out = out.replace(/-+$/, '');
    }

    return out;
};

export const sanitizeProjectName = (value, opts) => sanitizeName(value, opts);

export const sanitizeTaskName = (value, opts) => sanitizeName(value, opts);


